import styled, { css } from 'styled-components';
import { darkgrey, grey, warningred, white } from 'styles/Colors';

export const Item = styled.div<{
  success: boolean;
  isFirstSuccess: boolean;
  isLastSuccess: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  error?: boolean;
  isFirstError?: boolean;
  isLastError?: boolean;
}>`
  display: flex;
  justify-content: center;
  padding: 1px 6px;
  border: 2px solid transparent;
  color: ${grey};
  width: 30px;

  ${(props) =>
    props.success &&
    css`
      border: 2px solid #090;
      border-left: none;
      border-right: none;
      background-color: ${white};
      color: ${darkgrey};

      ${props.success &&
      props.isFirstSuccess &&
      !props.error &&
      css`
        border-top-left-radius: 60px;
        border-bottom-left-radius: 60px;
        border-left: 2px solid #090;
      `};

      ${props.success &&
      props.isLastSuccess &&
      !props.error &&
      css`
        border-top-right-radius: 60px;
        border-bottom-right-radius: 60px;
        border-right: 2px solid #090;
      `};
    `};

  ${(props) =>
    props.error &&
    css`
      border: 2px solid ${warningred};
      border-left: none;
      border-right: none;
      background: rgba(208, 2, 27, 0.1);
      color: ${darkgrey};

      ${props.error &&
      props.isFirstError &&
      css`
        border-top-left-radius: 60px;
        border-bottom-left-radius: 60px;
        border-left: 2px solid ${warningred};
      `};

      ${props.error &&
      props.isLastError &&
      css`
        border-top-right-radius: 60px;
        border-bottom-right-radius: 60px;
        border-right: 2px solid ${warningred};
      `};
    `}
`;
